/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronRight: {
  name: 'chevron-right';
  data: string;
} = {
  name: 'chevron-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.293 7.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L12.586 12 9.293 8.707a1 1 0 0 1 0-1.414Z" fill="currentColor"/></svg>`,
};
